(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["s2as-brand-directory"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded',function(){document.querySelectorAll('.s2as-brands').forEach(function(section){var input=section.querySelector('[data-brand-search]');var buttons=section.querySelectorAll('[data-brand-letter]');var cards=section.querySelectorAll('[data-brand-name]');var empty=section.querySelector('[data-brand-empty]');var activeLetter='all';function update(){var term=input.value.trim().toLowerCase();var visible=0;cards.forEach(function(card){var matchesLetter=activeLetter==='all'||card.dataset.brandInitial===activeLetter;var matchesSearch=!term||card.dataset.brandName.indexOf(term)!==-1;card.hidden=!(matchesLetter&&matchesSearch);if(!card.hidden)visible+=1});empty.hidden=visible!==0}input.addEventListener('input',update);buttons.forEach(function(button){button.addEventListener('click',function(){activeLetter=button.dataset.brandLetter;buttons.forEach(function(item){item.classList.toggle('is-active',item===button)});update()})})})});

  } catch(e) { console.error(e); }
})();
})();
